export const arsMainDependencies = function($state, $stateParams, store, ArsConfig, $mdDialog,
                                          applicationInformation, $cookies, $document)  {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.store = store;
        this.ArsConfig = ArsConfig;
        this.$mdDialog = $mdDialog;
        this.serializer = applicationInformation.serializer;
        this.cookies = $cookies;
        this.document = $document;
        return this;
};
